import { render, staticRenderFns } from "./registry.vue?vue&type=template&id=082df722&scoped=true"
import script from "./registry.ts?vue&type=script&lang=ts&external"
export * from "./registry.ts?vue&type=script&lang=ts&external"
import style0 from "./registry.scss?vue&type=style&index=0&id=082df722&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "082df722",
  null
  
)

export default component.exports